'use client'

import { type ReactNode } from 'react'

import CookieScript from './CookieScript'

const GTM_ID = 'GTM-WZLN3V4'

const SURVEY_ID = process.env.NEXT_PUBLIC_SURVEY_ID
const CASSIE_LICENSE_KEY = process.env.NEXT_PUBLIC_CASSIE_LICENSE_KEY
const CASSIE_HOST = process.env.NEXT_PUBLIC_CASSIE_HOST

const SURVEY_WIDGET_HOST = 'https://pax-survey-widget.vercel.app'
const SURVEY_WIDGET_HOST_NONPROD = 'https://pax-survey-widget-nonprod.vercel.app'

export const ScriptWrapper = ({
  children,
  environment,
  locale,
  script,
}: {
  children: ReactNode
  environment: string
  locale: string
  script: React.ElementType
}) => {
  const Script = script

  return (
    <>
      <CookieScript as={script} cassieHost={CASSIE_HOST} environment={environment} licenseKey={CASSIE_LICENSE_KEY} locale={locale} />
      {children}
      <Script
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : [];`,
        }}
        id="dataLayer"
      />
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', '${GTM_ID}');
          `,
        }}
        id="gtag-base"
        strategy="afterInteractive"
      />
      {/* ###### Survey Tool - only loaded if NEXT_PUBLIC_SURVEY_ID is present ###### */}
      {SURVEY_ID && typeof window !== 'undefined' && window.location.hostname !== 'localhost' ? (
        <>
          <div className="z-[999]" id="pax-survey-widget-root" />
          <Script
            onLoad={() => {
              // Initialize the survey widget after the script loads
              if (typeof window !== 'undefined' && (window as any).SurveyWidget) {
                ;(window as any).SurveyWidget.init({
                  containerId: 'pax-survey-widget-root',
                  isPreview: false,
                  showAlways: true,
                  surveyId: SURVEY_ID,
                })
              }
            }}
            src={`${environment === 'test' ? SURVEY_WIDGET_HOST_NONPROD : SURVEY_WIDGET_HOST}/pax-survey-widget.iife.js`}
            strategy="afterInteractive"
          />
        </>
      ) : null}
      <noscript>
        <iframe
          height="0"
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          style={{ display: 'none', visibility: 'hidden' }}
          title="gtag"
          width="0"
        />
      </noscript>
    </>
  )
}
